import { axios } from '..';
import config from '../config';
import { AddSiteWorkerRequest, DormantWorkerDTO, DormantWorkersRequestProps } from '../types';

const GW_URL = `${config.gatewayApiUrl}`;

export const addSiteWorkerRequest = ({ companyId, shiftId, siteId, worker }: AddSiteWorkerRequest) => {
  return axios.post(
    `${GW_URL}/public/v1/time/companies/${companyId}/sites/${siteId}/shifts/${shiftId}/users/add`,
    { workers: [worker] }
  );
};

export const getDormantWorkersRequest = ({
  companyId,
  payload,
  signal,
}: {
  companyId: string;
  payload: DormantWorkersRequestProps;
  signal?: AbortSignal;
}) => {
  return axios.post<{ count: number; items: DormantWorkerDTO[] }>(
    `${GW_URL}/admin/v1/time/monitoring/companies/${companyId}/workers/dormant`,
    payload,
    { signal }
  );
};
